module.exports = __webpack_public_path__ + "static/media/holeriteIcon.ef27b84e.svg";